// src/icons/constants.tsx
var invertFillColor = "invert-fill-color";
var invertStrokeColor = "invert-stroke-color";

export {
  invertFillColor,
  invertStrokeColor
};
